import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class HotelSettingsTaxesController extends Controller {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get taxes() {
    const inclusive = this.intl.t('settings.rates.inclusive');
    const exclusive = this.intl.t('settings.rates.exclusive');

    return {
      VAT: this.hotelAndMarketService.hotel.includeVat ? inclusive : exclusive,
      cityTax: this.hotelAndMarketService.hotel.includeCityTaxes
        ? inclusive
        : exclusive,
      otherTaxes: this.hotelAndMarketService.hotel.includeOtherTaxes
        ? inclusive
        : exclusive,
    };
  }
}
